export const generatorCategories = [
  { id: 1, name: 'building', description: 'Structures and architectural elements' },
  { id: 2, name: 'furniture', description: 'Chairs, tables, and other household furnishings' },
  { id: 3, name: 'urban', description: 'City-related objects and infrastructure' },
  { id: 4, name: 'medieval', description: 'Historical artifacts from the Middle Ages' },
  { id: 5, name: 'household', description: 'Everyday items used at home' },
  { id: 6, name: 'weapon', description: 'Offensive and defensive arms' },
  { id: 7, name: 'outdoor', description: 'Nature, landscapes, and exterior objects' },
  { id: 8, name: 'kitchen', description: 'Cooking tools, appliances, and utensils' },
  { id: 9, name: 'sci-fi', description: 'Futuristic and science fiction objects' },
];
